(function(angular){
	'use strict';
	
	angular
		.module('homeModule', [
			'coreModule',
			'historicalPerformanceChartModule',
			'planModule',
			'reitElementListingModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);